module.exports = __webpack_public_path__ + "img/9791195752911.50f7ee46.jpg";